define(function (require) {
    "use strict";

    var LE = require("app");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");
    var LEResourceResolver = require("leResourceResolver");
    var LEConfig = require("assets/config/le-env-conf");

    var CONST = {
        MODEL_DUMMY_ID: "dummy_id",
        TAGLET_CONFIGS_COLLECTION_KEY: "accountList.account.0.tagletConfigsCollection",
        TAGLET_CONFIGS_KEY: "accountList.account.0.tagletConfigsCollection.tagletConfigs",
        LPTAG_DELETE_API_URL_TAGLET_NAME_PLACEHOLDER: "{tagletName}",
        LPTAG_DELETE_API_URL_TAGLET_VERSION_PLACEHOLDER: "{DSTagletVersion}",
        SCRAPER_TAGLET_NAME: "sdeInfoScraper",
        SCRAPER_TAGLET_ID: String(LEConfig.scraperTagletId),
        OLD_TAGLET_VERSION: "1.0",
        NEW_TAGLET_VERSION: "NA"
    };
    var DataSourcesTagletModel = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        DataSourcesTagletModel = RevisionedModel.extend({
            resource: ApiResources.AccountConfig.LpTag,
            name: "DataSourcesTagletModel",
            initialize: function(models, options) {
                LEManager.logger.debug("DataSourcesTagletModel:initialize - start");
                RevisionedModel.prototype.initialize.call(this, options);
                /*since api version 4.0 it is possible to save the taglet according a taglet name
                * instead of a taglet id which was environment dependant. For backward compatibility
                * we will save the model according both ways. Same for taglet version. */
                this._initTagletNameAndVersions();
                this.originalLptagDeleteResource = $.extend(true, {}, ApiResources.AccountConfig.LpTagDelete);
            },

            url: function(){ //we need to override backbone to not include '/' and the temp id we give to the model
                //hack from version 1.0. we need to remove the /{empty_id} after save is called and executing backbone sync
                LEManager.logger.debug("DataSourcesTagletModel:url");
                var url = RevisionedModel.prototype.url.apply(this, arguments);

                //dummy id is used as a hack so the revision model save and destroy can work normally with the current version of the API not fully compliant with the rest of the ac apis
                if (this.get("id") === CONST.MODEL_DUMMY_ID){//by default we remove the dummy_id from the url
                    url = url.replace("/" + CONST.MODEL_DUMMY_ID, "");
                }
                LEManager.logger.debug("url: " + url, "DataSourcesTagletModel:url");
                return url;
            },

            _initTagletNameAndVersions: function(){
                this.tagletName = CONST.SCRAPER_TAGLET_NAME;
                this.tagletVersion = CONST.NEW_TAGLET_VERSION;
            },

            getQueryString: function(status){
                LEManager.logger.debug("DataSourcesTagletModel:getQueryString");
                //another weird issue with version 4.0 api. there si no update according a specific taglet id. only the delete has...
                var result = "";
                if (status.isNew){
                    result = ManagerConfig.dataSources.mainConfig.scraper.newTagletQS;
                }
                else if (status.isDelete){
                    result = ManagerConfig.dataSources.mainConfig.scraper.deleteTagletQS;
                }
                LEManager.logger.debug("qs: " + result, "DataSourcesTagletModel:getQueryString");
                return result;
            },

            getApiResourcesUrl: function(status){
                LEManager.logger.debug("DataSourcesTagletModel:getApiResourcesUrl");
                var result = "";
                if (status.isDelete){
                    result = $.extend(true, {}, this.originalLptagDeleteResource);
                    result.url = result.url.replace(CONST.LPTAG_DELETE_API_URL_TAGLET_NAME_PLACEHOLDER, this.tagletName).replace(CONST.LPTAG_DELETE_API_URL_TAGLET_VERSION_PLACEHOLDER, this.tagletVersion);
                }
                else {
                    result = LEResourceResolver.apiResources.AccountConfig.LpTag;
                }
                LEManager.logger.debug("api resource url: " + result, "DataSourcesTagletModel:getApiResourcesUrl");
                return result;
            },

            getHttpMethod: function(status){
                LEManager.logger.debug("DataSourcesTagletModel:getHttpMethod");
                var result = "";
                if (status.isNew){
                    result = "POST";
                }
                else if (status.isDelete){
                    result = "DELETE";
                }
                else {
                    result = "PUT";
                }
                LEManager.logger.debug("http method: " + result, "DataSourcesTagletModel:getHttpMethod");
                return result;
            },

            getParametersConfig: function(){
                LEManager.logger.debug("DataSourcesTagletModel:getParametersConfig");
                var result = [];
                var tagletConfig = this.getTagletConfig();
                if (_.has(tagletConfig, "parameters")){
                    var parameters = tagletConfig.parameters;
                    for(var i=0; i < parameters.length; i++){
                        if (_.isString(parameters[i].value)){
                            parameters[i].value = JSON.parse(parameters[i].value);
                        }
                    }
                    result = parameters;
                }
                LEManager.logger.debug("parameters config: " + result, "DataSourcesTagletModel:getParametersConfig");
                return result;
            },

            getTagletConfigsArray: function(){
                LEManager.logger.debug("DataSourcesTagletModel:getTagletConfigsArray");
                var result = [];
                var accountConfig = _.find(this.get("accountList").account, function(account){
                    return account.id === LE.sessionManager.getAccountId();
                });
                if (accountConfig && accountConfig.tagletConfigsCollection){
                    result = accountConfig.tagletConfigsCollection;
                }
                LEManager.logger.debug("TagletConfigsArray: " + result, "DataSourcesTagletModel:getTagletConfigsArray");
                return result;
            },

            getTagletConfig: function(){
                LEManager.logger.debug("DataSourcesTagletModel:getTagletConfig");
                var result;
                var tagletConfigsArray = this.getTagletConfigsArray();
                if (_.has(tagletConfigsArray, "tagletConfigs")){
                    //first we check if the config data is done according the taglet name
                    var tagletconfigByTagletName = _.find(tagletConfigsArray.tagletConfigs, function(tagletConfig){
                        return tagletConfig.tagletName === CONST.SCRAPER_TAGLET_NAME;
                    });
                    if (!_.isUndefined(tagletconfigByTagletName)){
                        //if defined, we will use the corresponding taglet name and version for the future api actions
                        this.tagletName = CONST.SCRAPER_TAGLET_NAME;
                        this.tagletVersion = CONST.NEW_TAGLET_VERSION;
                        result = tagletconfigByTagletName;
                    }
                    else {
                        //the config data was stored according the taglet id (api version prior to 4.0)
                        var tagletconfigByTagletId = _.find(tagletConfigsArray.tagletConfigs, function(tagletConfig){
                            return tagletConfig.tagletName === CONST.SCRAPER_TAGLET_ID;
                        });
                        if (!_.isUndefined(tagletconfigByTagletId)){
                            //we will use the taglet id and 1.0 as the version for the future use of the api
                            this.tagletName = CONST.SCRAPER_TAGLET_ID;
                            this.tagletVersion = CONST.OLD_TAGLET_VERSION;
                            result = tagletconfigByTagletId;
                        }
                    }
                }
                LEManager.logger.debug("tagletConfig: " + result, "DataSourcesTagletModel:getTagletConfig");
                return result;
            },

            hasParametersDefined: function(){
                LEManager.logger.debug("DataSourcesTagletModel:hasParametersDefined");
                var tagletConfig = this.getTagletConfig();
                var result = _.has(tagletConfig, "parameters") && tagletConfig.parameters.length > 0;
                return result;
            },

            resetConfigs: function(){
                LEManager.logger.debug("DataSourcesTagletModel:resetConfigs");
                var config = this.getTagletConfig();
                var tagletName = this.tagletName;
                config = _.without(config, _.find(config, {tagletName: tagletName}));
                this.set(CONST.TAGLET_CONFIGS_KEY, config);
                this._initTagletNameAndVersions();
            },

            getTagletName: function(){
                return this.tagletName;
            },

            getTagletVersion: function(){
                return this.tagletVersion;
            },

            saveTaglet: function(status, tagletRequest, options){
                LEManager.logger.debug("DataSourcesTagletModel:saveTaglet");

                var qs = this.getQueryString(status);
                var url = this.getApiResourcesUrl(status);
                this.resource = LEResourceResolver.getUrl(url) + qs;

                var success = options.success;
                var error = options.error;
                var newSuccess = function(model, response, options) {
                    if (success) {
                        success.apply(this, arguments);
                    }
                };

                var newError = function(model, response, options) {
                    if (error) {
                        error.apply(this, arguments);
                    }
                };

                var _options = _.extend(options, {
                    data: tagletRequest,
                    type: this.getHttpMethod(status),
                    contentType: "application/json",
                    success:_.bind(newSuccess, this),
                    error:_.bind(newError, this)
                });

                //this is a hack so that the revision model makes the update/delete correctly.
                //if not set it makes an insert all the time
                if (!status.isNew){
                    this.set("id", CONST.MODEL_DUMMY_ID);
                }
                else {
                    this.unset("id");
                }

                if (status.isDelete){
                    options.wait= true;
                    this.destroy(_options);
                }
                else {
                    this.set(CONST.TAGLET_CONFIGS_COLLECTION_KEY, tagletRequest);
                    this.save(null, _options);
                }
            }
        });
    });

    return DataSourcesTagletModel;
});
